import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnlyAdminAuthorizedGuard } from '@web/app/services/guards/only-admin-authorized.guard';
import { LoginAsWineryResolverService } from "@services/dws/resolvers/login-as-winery-resolver.service";
import { LoginAsWineryComponent } from "@web/app/pages/admin/login-as-winery/login-as-winery.component";

const routes: Routes = [
  {
    path: '',
    component: LoginAsWineryComponent,
    canActivate: [OnlyAdminAuthorizedGuard],
    resolve: {
      wineries: LoginAsWineryResolverService
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginAsWineryRoutingModule {}
